import React from "react";
import "./FloatingButton.css"; // Import the CSS file

const FloatingButton = () => {
  return (
    <div className="floating-button">
      <a target='_blank' rel="noopener noreferrer" href="https://www.linkedin.com/showcase/flipkart-ads/">
        <img src="/img/linkedin.png" alt="Floating Icon" />
      </a>
    </div>
  );
};

export default FloatingButton;
